import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { copyText } from "../../../helpers/functions";
import { FaCopy } from "react-icons/fa";

const CasinoBetDetailModal = ({ data }) => {
  const { t } = useTranslation();
  return (
    <div className="grid md:grid-cols-2 grid-cols-1 gap-4" style={{ padding: "0 40px 40px" }}>
      <div className="block">
        <label className="block text-[#ababab] text-md font-medium">Player Id</label>
        <span className="flex items-center text-white" required autoComplete="off">
          {data?.userId}{" "}
          <span className="ml-5 text-slate-400 " onClick={() => copyText(data?.userId)}>
            <FaCopy />
          </span>
        </span>
      </div>{" "}
      <div className="block mb-2">
        <label className="block text-[#ababab] text-md font-medium">{t("User name")}</label>
        <span className="text-white" required autoComplete="off">
          {data?.sender?.username}
        </span>
      </div>{" "}
      <div className="block">
        <label className="block text-[#ababab] text-md font-medium">{t("Bet Id")}</label>
        <span className="flex items-center text-white" required autoComplete="off">
          {data?.transaction_id}{" "}
          <span className="ml-5 text-slate-400 " onClick={() => copyText(data?.transaction_id)}>
            <FaCopy />
          </span>
        </span>
      </div>{" "}
      <div className="block">
        <label className="block text-[#ababab] text-md font-medium">Created</label>

        <span className="text-white" required autoComplete="off">
          {moment(data?.date).format("YYYY-MM-DD hh:mm:ss")}
        </span>
      </div>{" "}
      <div className="block">
        <label className="block text-[#ababab] text-md font-medium">{t("Game name")}</label>
        <span className="text-white" required autoComplete="off">
          {data?.gameName ? data?.gameName : "-"}
        </span>
      </div>
      <div></div>
      <div className="block">
        <label className="block text-[#ababab] text-md font-medium">{t("Stake")}</label>

        <span className="text-white" required autoComplete="off">
          {data?.stake} <span className="text-slate-400">{data.currency}</span>
        </span>
      </div>
      <div className="block">
        <label className="block text-[#ababab] text-md font-medium">{t("Payout")}</label>

        <span className="text-white" required autoComplete="off">
          {data?.payout} <span className="text-slate-400"> {data.currency}</span>
        </span>
      </div>
      <div className="block">
        <label className="block text-[#ababab] text-md font-medium">{t("Balance before")}</label>

        <span className="text-white" required autoComplete="off">
          {data?.balanceBefore?.sender} <span className="text-slate-400">{data.currency}</span>
        </span>
      </div>
      <div className="block">
        <label className="block text-[#ababab] text-md font-medium">{t("Balance after")}</label>

        <span className="text-white" required autoComplete="off">
          {data?.balanceAfter?.sender} <span className="text-slate-400">{data.currency}</span>
        </span>
      </div>
      <div className="block">
        <label className="block text-[#ababab] text-md font-medium">{t("Status")}</label>

        <span className="text-white" required autoComplete="off">
          {data?.type === "debit" ? "Lost" : "Won"}
        </span>
      </div>
      <div className="block">
        <label className="block text-[#ababab] text-md font-medium">{t("Paid out")}</label>

        <span className="text-white" required autoComplete="off">
          {data?.type === "debit" ? "-" : t("Paid out")}
        </span>
      </div>
      <div className="block">
        <label className="block text-[#ababab] text-md font-medium">{t("Draw Id")}</label>

        <span className="text-white" required autoComplete="off">
          {"-"}
        </span>
      </div>
      <div className="block">
        <label className="block text-[#ababab] text-md font-medium">{t("Draw time")}</label>

        <span className="text-white" required autoComplete="off">
          {"-"}
        </span>
      </div>
    </div>
  );
};

export default CasinoBetDetailModal;
